import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './styles/performance.css';
import './styles/translate.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

// Ensure root element exists
if (!rootElement) {
  throw new Error('Failed to find the root element. Make sure there is a <div id="root"></div> in your HTML.');
}

// Routes that react-snap has pre-rendered into their own HTML files.
// Only hydrate when the current path matches a pre-rendered route; otherwise
// fall back to a fresh createRoot render to avoid React error #418 caused by
// the 200.html/index.html fallback serving home-page HTML for unmatched paths.
const prerenderedRoutes = [
  '/',
  '/about',
  '/contact',
  '/cart',
  '/privacy-policy',
  '/terms-conditions',
  '/manufacturing',
];
const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
const isPrerendered =
  rootElement.hasChildNodes() && prerenderedRoutes.includes(currentPath);

const app = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

if (isPrerendered) {
  // Use hydrateRoot only when the pre-rendered HTML actually matches this route
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  // Fresh render for dynamic routes or when no pre-rendered content is present
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      {app}
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
